import { useState, useEffect, useRef } from "react";
import UiIcon from "./UiIcon";

export default function AccountMenu({ user, language, avatar, onLogout, onSettings }) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    const triggerRef = useRef(null);
    const closeMenu = () => { setOpen(false); triggerRef.current?.focus(); };
    useEffect(() => {
        if (!open) return undefined;
        menuRef.current?.querySelector('[role="menuitem"]')?.focus();
        const dismiss = event => {
            if (!menuRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener("pointerdown", dismiss);
        return () => document.removeEventListener("pointerdown", dismiss);
    }, [open]);
    const handleMenuKey = event => {
        if (!open && ["ArrowDown", "ArrowUp"].includes(event.key)) { event.preventDefault(); setOpen(true); return; }
        if (event.key === "Escape") { event.preventDefault(); closeMenu(); }
        if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
            event.preventDefault();
            const actions = [...menuRef.current.querySelectorAll('[role="menuitem"]')];
            const current = actions.indexOf(document.activeElement);
            const index = event.key === "Home" ? 0 : event.key === "End" ? actions.length - 1
                : (current + (event.key === "ArrowDown" ? 1 : -1) + actions.length) % actions.length;
            actions[index]?.focus();
        }
    };
    const labels = {
        fa: { settings: "تنظیمات", logout: "خروج از سامانه" },
        en: { settings: "Settings", logout: "Sign out" },
        fr: { settings: "Paramètres", logout: "Déconnexion" },
        ar: { settings: "الإعدادات", logout: "تسجيل الخروج" },
        es: { settings: "Configuración", logout: "Cerrar sesión" },
    }[language] || { settings: "Settings", logout: "Sign out" };
    const roleLabels = {
        fa: { specialist: "کارشناس", manager: "مدیر", deputy: "معاون", ceo: "مدیرعامل", admin: "ادمین" },
        en: { specialist: "Specialist", manager: "Manager", deputy: "Division lead", ceo: "CEO", admin: "Administrator" },
        fr: { specialist: "Spécialiste", manager: "Gestionnaire", deputy: "Direction", ceo: "PDG", admin: "Administrateur" },
    };
    const role = (roleLabels[language] || roleLabels.en)[String(user?.role || "").toLowerCase()] || user?.role;
    return <div className="cvi-user-menu" ref={menuRef} onKeyDown={handleMenuKey}>
        <button ref={triggerRef} aria-haspopup="menu" type="button" className="cvi-user-menu-trigger" onClick={() => setOpen(value => !value)} aria-expanded={open}>
            {avatar}
            <span className="cvi-user-menu-copy cvi-hide-xs"><strong>{user?.name}</strong><small>{role}</small></span>
            <UiIcon name="chevronDown" size={14} />
        </button>
        {open && <div className="cvi-user-menu-popover" role="menu" aria-label={labels.settings}>
            <div className="cvi-user-menu-person" role="presentation"><strong>{user?.name}</strong><span>{role}</span></div>
            <button type="button" role="menuitem" className="cvi-user-menu-settings" onClick={() => { setOpen(false); onSettings(); }}>
                <UiIcon name="settings" size={17} />{labels.settings}
            </button>
            <button type="button" role="menuitem" className="cvi-user-menu-logout" onClick={() => { setOpen(false); onLogout(); }}>
                <UiIcon name="logout" size={17} />{labels.logout}
            </button>
        </div>}
    </div>;
}

